import { Loader2 } from 'lucide-react'
import { Navigate, useParams } from 'react-router-dom'
import { useConfiguration } from '@/hooks/useConfiguration'
import type { GuidedBuilderRouteProps } from './guidedBuilder.types'
import { fullBuilderPath } from './guidedBuilderPaths'

export function GuidedBuilderRoute({ children }: GuidedBuilderRouteProps) {
  const { id } = useParams()
  const { configuration, isLoading } = useConfiguration(id, { enabled: !!id })

  if (id && isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader2 className="size-6 animate-spin motion-reduce:animate-none text-muted-foreground" />
      </div>
    )
  }

  if (id && configuration?.creationType !== 'guided') {
    return <Navigate to={fullBuilderPath(id)} replace />
  }

  if (id && configuration?.status === 'published') {
    return <Navigate to={fullBuilderPath(id)} replace />
  }

  return children
}
